import { mapState } from 'vuex';
import eventNames from '@/constants/analyticsEventNames';
import { datadogRum } from '@datadog/browser-rum';
import { telemetryUserAttributes as telemetryUserAttributesHelper, addAppSpecificData } from '@/utilities/analytics';

const instrumentationMixin = {
  computed: {
    ...mapState([
      'devTools',
    ]),
    telemetryUserAttributes() {
      return telemetryUserAttributesHelper(this.$store.getters?.currentUser);
    },
  },
  data() {
    return {
      eventNames,
    };
  },
  methods: {
    log(message) {
      const loggingEnabled = this.devTools ? this.devTools.analyticsLoggingEnabled : false;
      if (import.meta.env.DEV && loggingEnabled) {
        window.console.info(`Analytics - EVENT: ${message}`);
      }
    },

    trackDatadog(title, data) {
      if (import.meta.env.VITE_THIRD_PARTY_JS_ENABLED === 'true') {
        const localData = addAppSpecificData(data);
        datadogRum.addAction(title, localData);
      }
    },
    trackMixPanel(title, data = {}) {
      const localData = addAppSpecificData(data);
      if (window.mixpanel) {
        window.mixpanel.track(title, localData);
      }
    },
    track(title, data) {
      // eslint-disable-next-line camelcase
      const userId = data?.userId || data?.user_id || this?.telemetryUserAttributes?.user_id;
      const compiledData = {
        user_id: userId,
        ...data,
      };
      this.log(`${title}, DATA: ${JSON.stringify(compiledData)}`);
      this.trackMixPanel(title, compiledData);
      this.trackDatadog(title, compiledData);
    },
    recordAuditTrail(
      auctionId,
      bidAmount,
      sellerOrBuyer,
      acceptedOrRejected,
      fromRecommendations = false,
      fromFastActionPanel = false,
      fromAuctionDetailPage = false,
      source = '',
    ) {
      const { currentUser } = this.$store.getters;
      const auditMessage = `Auction #${auctionId} the ${sellerOrBuyer}, user ${currentUser.user_id}, ${acceptedOrRejected} $${bidAmount} at ${new Date()}, from web`;
      this.track('Audit Trail', {
        auction_id: auctionId,
        value: bidAmount,
        label: auditMessage,
        from_recommendations: fromRecommendations,
        from_fast_action_panel: fromFastActionPanel,
        source,
      });

      if (acceptedOrRejected === 'accepted') {
        this.track('Payment Pending', {
          auction_id: auctionId,
          amount: bidAmount,
          user_id: currentUser.user_id,
          who_accepted: sellerOrBuyer,
          from_recommendations: fromRecommendations,
          from_fast_action_panel: fromFastActionPanel,
          from_auction_detail_page: fromAuctionDetailPage,
          source,
        });
      }
    },
    setupCustomAnalyticsAttributes() {
      const { currentUser } = this.$store.getters;
      if (window.mixpanel) {
        window.mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN);
        window.mixpanel.people.set(this.telemetryUserAttributes);
        window.mixpanel.identify(currentUser.user_id);
      }

      if (import.meta.env.VITE_THIRD_PARTY_JS_ENABLED === 'true') {
        datadogRum.setUser({ id: currentUser.id, ...this.telemetryUserAttributes });
      }

      this.log(`Tracking User Set: ${JSON.stringify(this.telemetryUserAttributes)}`);
    },

    noticeError(error, customAttributes = {}) {
      const errorMessage = error.message || 'NO MESSAGE';
      this.log(`Error Noticed - MESSAGE: ${errorMessage}, DATA: ${JSON.stringify(customAttributes)}`);
      if (import.meta.env.VITE_THIRD_PARTY_JS_ENABLED === 'true') {
        datadogRum.addError(error, customAttributes);
      }
    },
  },
};

export default instrumentationMixin;
